import { render } from "./FeatureCard.vue?vue&type=template&id=6a67b37e&scoped=true&lang=pug"
import script from "./FeatureCard.vue?vue&type=script&lang=ts"
export * from "./FeatureCard.vue?vue&type=script&lang=ts"

import "./FeatureCard.vue?vue&type=style&index=0&id=6a67b37e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6a67b37e"

export default script